import React from "react";

import "@atlaskit/tokens/figma/atlassian-light.json";
import "@atlaskit/tokens/figma/atlassian-dark.json";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

import { FourOhFourPageTemplate } from "../../../../404/404-page/src/404-page.template";

import { FastshiftPortalPageRouter } from "./fastshift-portal-page-router";

export const FastshiftDashboardPageTemplate: React.FC = () => {
    const isFastshiftPortalEnabled = checkFeatureFlagGate(
        featureFlags.sxpEnableFastshiftPortal
    );

    if (!isFastshiftPortalEnabled) {
        return <FourOhFourPageTemplate />;
    }

    return <FastshiftPortalPageRouter />;
};
